import { ADMIN_LANGUAGES } from "./LanguageTabs";

function PlaceModal({ place, setPlace, translating, onTranslate, onSave, onClose }) {
    const updateField = (field, value) => setPlace((current) => ({ ...current, [field]: value }));

    return (
        <div className="admin__modal-overlay" onClick={onClose}>
            <div className="admin__modal admin__modal--small card-common" onClick={(e) => e.stopPropagation()}>
                <div className="admin__modal-title-row">
                    <h2>{place.id ? "Editează" : "Adaugă"} Loc</h2>
                    <button
                        type="button"
                        className="admin__btn-ai"
                        onClick={onTranslate}
                        disabled={translating || !String(place.name || "").trim()}>
                        {translating ? "Se traduce..." : "Tradu cu AI"}
                    </button>
                </div>
                <form onSubmit={onSave}>
                    {ADMIN_LANGUAGES.map((language) => (
                        <div className="admin__field" key={language.code}>
                            <label>
                                Nume ({language.name}){language.code === "ro" ? " *" : ""}
                            </label>
                            <input
                                type="text"
                                value={place[`name${language.suffix}`] || ""}
                                onChange={(e) => updateField(`name${language.suffix}`, e.target.value)}
                                required={language.code === "ro"}
                                placeholder={language.code === "ro" ? "" : "Gol = se afișează numele în română"}
                            />
                        </div>
                    ))}
                    <div className="admin__modal-actions">
                        <button type="button" onClick={onClose} disabled={translating}>
                            Anulează
                        </button>
                        <button type="submit" className="primary" disabled={translating}>
                            Salvează
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default PlaceModal;
